import { useEffect, useState } from "react";
import api from "@/lib/api";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import StockSection from "@/components/site/StockSection";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

export default function HomePage() {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const r = await api.get("/settings");
                setSettings(r.data);
            } catch {
                // ignore
            }
        })();
    }, []);

    return (
        <div data-testid="home-page" className="min-h-screen bg-[#0a0a0a] text-white">
            <Header phone={settings?.phone} />
            <Hero />
            <StockSection settings={settings} />
            <ContactSection settings={settings} />
            <Footer settings={settings} />
            <WhatsAppButton settings={settings} />
        </div>
    );
}
